import React from "react";
import { Dialog, DialogContent, IconButton, Typography, Box, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageAssets from "../../assets";

const DownloadAppPopup = ({ open, onClose }) => {
    const isMobile = useMediaQuery("(max-width:768px)"); // Detects mobile screens

    const handlePlayStore = () => {
        window.open('https://play.google.com/store/apps/details?id=com.sekeron.artistcollabapp', '_blank');
    }

    const handleAppleStore = () => {
        window.open('https://apps.apple.com/us/app/sekeron/id6475784075', '_blank');
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogContent
                sx={{
                    position: "relative",
                    background: "#17171C",
                    borderRadius: "16px",
                    padding: isMobile ? "2rem" : "4rem" // Smaller padding on mobile
                }}
            >
                {/* Close Button */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        color: "white",
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Content Box */}
                <Box
                    display="flex"
                    flexDirection={isMobile ? "column" : "row"} // Stack on mobile, row on desktop
                    alignItems="center"
                    gap={isMobile ? 3 : 6}
                >
                    {/* Left Side - Mobile Mockup */}
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            width: isMobile ? "100%" : "auto"
                        }}
                    >
                        <img
                            src={ImageAssets.ic_sekeron_app}
                            alt="Mobile Mockup"
                            style={{
                                maxWidth: isMobile ? "200px" : "250px", // Smaller on mobile
                                width: "100%",
                                borderRadius: "12px"
                            }}
                        />
                    </Box>

                    {/* Right Side - Text & Buttons */}
                    <Box
                        sx={{
                            flex: 2,
                            textAlign: "center", // Centered text on all screens
                            color: "white"
                        }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight={700}
                            style={{ fontSize: isMobile ? "2rem" : "3rem" }}
                        >
                            Download Our Mobile App
                        </Typography>

                        <Typography
                            sx={{
                                opacity: 0.8,
                                marginBottom: 2,
                                marginTop: 2,
                            }}
                            style={{ fontSize: isMobile ? "1.5rem" : "2rem" }}
                        >
                            Sekeron: Artist Collab App
                        </Typography>

                        {/* App Store & Google Play Buttons */}
                        <Box
                            display="flex"
                            gap={2}
                            justifyContent="center"
                            alignContent={"center"}
                            flexDirection={isMobile ? "row" : "row"} // Stack buttons on mobile
                        >
                            <img
                                onClick={handleAppleStore}
                                src={ImageAssets.ic_app_store}
                                alt="App Store"
                                style={{
                                    width: isMobile ? "150px" : "200px",
                                    cursor: "pointer",
                                }}
                            />
                            <img
                                onClick={handlePlayStore}
                                src={ImageAssets.ic_google_play}
                                alt="Google Play"
                                style={{
                                    width: isMobile ? "150px" : "200px",
                                    cursor: "pointer"
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadAppPopup;
